import { notyf } from '@modules';

class CopyToClipboard extends HTMLElement {
  #resetTimer;

  connectedCallback() {
    this.addEventListener('click', () => this.copyToClipboard());
    this.addEventListener('keydown', (event) => this.#handleKeydown(event));
  }

  /**
   * Keyboard activation — the element is exposed as `role="button" tabindex="0"`,
   * so Enter and Space must trigger the same copy as a click. Space is
   * preventDefault'd to stop the page from scrolling.
   */
  #handleKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    if (event.key === ' ') event.preventDefault();
    this.copyToClipboard();
  }

  disconnectedCallback() {
    clearTimeout(this.#resetTimer);
  }

  /**
   * Copy to clipboard
   */
  async copyToClipboard() {
    try {
      await navigator.clipboard.writeText(this.dataset.value);
      notyf.success(this.dataset.successMessage || 'Copiato negli appunti');
      this.#flashCopied();
    } catch (error) {
      notyf.error(error.message);
    }
  }

  /**
   * Transient `.is-copied` state so callers can render a "copied" affordance
   * (e.g. the campaign coupon box). Auto-clears after 2s. Additive — callers
   * without styling for it are unaffected.
   */
  #flashCopied() {
    this.classList.add('is-copied');
    clearTimeout(this.#resetTimer);
    this.#resetTimer = setTimeout(() => this.classList.remove('is-copied'), 2000);
  }
}

customElements.define('copy-to-clipboard', CopyToClipboard);
